<app-leveltwo [pageName]="'Data Sales'">
<div class="General">
  <h3>{{'OnlinePDB.SearchTitle'|translate}}</h3>
  <h4>{{'OnlinePDB.Assessor'|translate}}</h4>
  <h5>{{'OnlinePDB.Background'|translate}}</h5>
  <p>{{'OnlinePDB.Theassessors'|translate}}</p>

  <ol>
    <li>{{'OnlinePDB.ain'|translate}}</li>
    <li>{{'OnlinePDB.assesseename'|translate}}</li>
    <li>{{'OnlinePDB.situsaddress'|translate}}</li>
  </ol>

  <p [innerHTML]="'OnlinePDB.Thepurpose'|translate"></p>
  <p [innerHTML]="'OnlinePDB.Oryoumay'|translate"></p>

  <h5>{{'OnlinePDB.Subscriptionfees'|translate}}</h5>
  <ol>
    <li>{{'OnlinePDB.Monthly'|translate}}</li>
    <li>{{'OnlinePDB.signupfee'|translate}}</li>
  </ol>

  <h5>{{'OnlinePDB.Requestingaccess'|translate}}</h5>
  <p>{{'OnlinePDB.Torequest'|translate}}</p>
  <strong>Section Manager - Help Desk<br>
  Los Angeles County Assessor's Office<br>
  500 W. Temple Street, Room 291 <br>
  Los Angeles, CA 90012-2770<br></strong><br>

  <p [innerHTML]="'OnlinePDB.Acontract2'|translate"></p>
  <p [innerHTML]="'OnlinePDB.Forfurther'|translate"></p>

</div>
</app-leveltwo>
